import React from 'react';

export const ZoikLogo: React.FC<{ size?: number }> = ({ size = 44 }) => {
  return (
    <img
      src="/zoik-logo.png"
      alt="ZOIK Logo"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '12px',
        objectFit: 'cover',
        display: 'block'
      }}
    />
  );
};

export default ZoikLogo;
